<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height pa-0>
        <v-layout v-if="showLog" align-center justify-center>
          <div id="wrap-banner" v-if="screenSaver.show" class="wrap-banner particles-js">
            <div class="page-auth">
              <v-flex pa-0 pb-3>
                <img alt="logo" src="@/nms/assets/e-node_logo_rus.png" style="width: 220px; opacity: .9">
              </v-flex>

              <form-login
                @logIn="(payload) => {onLogIn(payload)}"
                @KCLogIn="(payload) => {onKCLogIn(payload)}"
                @ADLogIn="(payload) => {onADLogIn(payload)}"
              />
            </div>
          </div>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>

</template>

<script lang="ts">
import Vue from 'vue'
import FormLogin from '@/nms/pages/auth/forms/form-login'
import { mapActions, mapGetters } from 'vuex'

// Типы
interface ScreenSaverState {
  show: boolean
  width: number | null
  height: number | null
}

interface UserData {
  login?: string
  password?: string
  subsystem?: string
  role?: string
  level?: number
  [key: string]: any
}

interface CheckLoggedResponse {
  logged?: boolean
  userId?: string
  userRoles?: string[]
  [key: string]: any
}

interface LoginResponse {
  role?: string
  [key: string]: any
}

interface AccessMap {
  administrator: number
  manager: number
  operator: number
  inform_secur_user: number
}

export default Vue.extend({
  name: 'AUTH_PAGE',

  components: {
    FormLogin,
  },

  computed: {
    ...mapGetters(['getPages']),
  },

  data(): {
    showLog: boolean
    stateReseted: boolean
    screenSaver: ScreenSaverState
  } {
    return {
      showLog: false,
      stateReseted: false,
      screenSaver: {
        show: false,
        width: null,
        height: null
      }
    }
  },

  watch: {
    showLog: {
      handler(newVal: boolean): void {
        if (newVal) {
          this.screenSaver.width = (this.$el as HTMLElement).clientWidth
          this.screenSaver.height = (this.$el as HTMLElement).clientHeight - 20
          this.screenSaver.show = true
          // this.setup('watch showLog')
        }
      },
      deep: true
    },
  },

  created(): void {
    this.setup('created')
  },

  methods: {
    ...mapActions([
      'resetStructureState',
      'resetDevicesState',
      'resetAuthState',
    ]),

    async setup(caller?: string): Promise<void> {
      if (this.showLog) {
        this.screenSaver.width = (this.$el as HTMLElement).clientWidth
        this.screenSaver.height = (this.$el as HTMLElement).clientHeight - 20
        this.screenSaver.show = true
      }

      if (!this.stateReseted) {
        await this.resetAuthState()
        await this.resetStructureState()
        await this.resetDevicesState()
        this.stateReseted = true
      }

      this.checkLogged(caller)
    },

    async checkLogged(caller?: string): Promise<void> {
      console.log(this.$options.name, 'checkLogged this.$route', this.$route, 'caller', caller)

      // this.showLog = true
      let routeToPath = this.$route.params?.to ? this.$route.params.to.path : '/login'
      this.showLog = false

      const logged = await this.$bridge.isLogged(true) as CheckLoggedResponse
      console.log(this.$options.name, 'check$', logged)

      if (logged) {

        let session = await this.$bridge.getSession()
        if (session) {
          // console.log("STORE checkForLogged session", session)

          const user: UserData = { subsystem: 'common' }
          const access: AccessMap = {
            administrator: 0,
            manager: 1,
            operator: 2,
            inform_secur_user: 3
          }

          user.role = session.role_nms
          user.level = access[user.role as keyof AccessMap] ?? 2
          user.login = session.username

          user.role_enode = session.role_enode
          user.role_project = session.role_project
          user.user_id = session.user_id

          if (user.level === 0 || user.level === 1) {
            await this.$bridge.disableBrowserCache()
          } else {
            await this.$bridge.enableBrowserCache()
          }

          if(session.mqtt) {
            this.$bridge.setMqttToken(session.mqtt)
          }

          this.$store.dispatch('setLogged', true)
          this.$store.dispatch('setLoggedUser', user)
          console.log("STORE checkForLogged path", this.$route.params.to)
          console.log("STORE checkForLogged routeToPath", routeToPath)
          this.showLog = true
          this.$router.push({ path: routeToPath })

        }
        else {
          this.showLog = true
          this.$router.push({ path: '/login' })
          return
        }

      } else {
        this.showLog = true
        this.$router.push({ path: '/login' })
      }
    },

    async onLogIn(user: UserData): Promise<void> {
      this.$store.dispatch('setLoader')
      const store = this.$store.state as any

      if (!store.structure.uiLoaded) {
        alert('load license false')
        return
      }

      try {
        const l = await this.$store.dispatch('login', { user: user.login, password: user.password }) as LoginResponse
        await this.setLoggedParams(l, user)
      } catch (err) {
        this.$errorHandler(err)
        this.$router.push({ name: 'login' })
      }
    },

    async onKCLogIn(): Promise<void> {
      try {
        const keycloak = (this as any).$keycloak
        if (keycloak?.url) {
          window.location.replace(keycloak.url)
        } else {
          window.location.replace('https://192.168.244.2:8443/realms/NMS/protocol/openid-connect/auth?client_id=NMS&redirect_uri=https://192.168.246.100/callback&response_type=code&scope=openid')
        }
        console.log(this.$options.name, 'onKCLogIn redirect')
        this.setLoader('onKCLogIn', true)
      } catch (err) {
        this.setLoader('onKCLogIn', false)
        this.$errorHandler(err)
        this.showLog = true
        this.$router.push({ name: 'login' })
      }
    },

    async onADLogIn(user: UserData): Promise<void> {
      console.log('onADLogIn', user)
      try {
        const l = await this.$store.dispatch('login', { user: user.login, password: user.password, AD: true }) as LoginResponse
        console.log(this.$options.name, 'onADLogIn connect', l)
        await this.setLoggedParams(l, user)
      } catch (err) {
        this.$errorHandler(err)
        this.showLog = true
        this.$router.push({ name: 'login' })
      }
    },

    async setLoggedParams(resp: LoginResponse, user: UserData): Promise<void> {
      try {
        this.$store.dispatch('setLogged', true)
        this.$store.dispatch('checkForLogged')

        const access: AccessMap = {
          administrator: 0,
          manager: 1,
          operator: 2,
          inform_secur_user: 3
        }

        this.$set(resp, 'level', access[resp.role as keyof AccessMap] ?? 2)

        if (resp.level === 0 || resp.level === 1) {
          await this.$bridge.disableBrowserCache()
        } else {
          await this.$bridge.enableBrowserCache()
        }

        this.$set(resp, 'subsystem', user.subsystem)
        await this.$store.dispatch('setLoggedUser', resp)

        this.screenSaver.show = false

        this.$store.dispatch('moduleChange', resp.subsystem)
        const pages = this.$store.getters.getPages
        this.$store.dispatch('pageChange', pages[0])
        this.$router.push({ name: pages[0] })
      } catch (err) {
        this.$errorHandler(err)
        this.$router.push({ name: 'login' })
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },
  },
})
</script>

<style lang="stylus">

    .page-auth
        background-color: #ffffff

        border: solid 1px #4989cc
        border-radius: 4px

        /* background-color: #1e1d1c */
        /* background-color: #2D2B2B */
        /* border: solid 1px #807878cc */
        display: flex
        flex-direction: column
        align-items: center
        position: relative
        position: absolute
        width: 270px
        height: auto
        padding: 20px 20px
        box-sizing: border-box

</style>

<style>

.wrap-banner {
  position: relative;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-flex;
  display: flex;
  height: 100%;
  justify-content: center;
}

body::-webkit-scrollbar {
  width: 0px;            
}

.particles-js {
  background-color: #1f1f1f;
  /* background-color: #1f1f1f; */
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

</style>
